<template>
  <div>

    <div class="ui huge menu">
      <a href="#" class="item" @click.prevent="triggerMenu">
        <i class="content icon"></i>
      </a>
      <div class="right menu"></div>
      <a href="#" class="red item" @click.prevent="addService"><i class="plus icon"></i> Add Service</a>
    </div>
    <div class="ui container">
      <h3 class="ui header">
        Services
      </h3>

      <div class="ui loader" :class="{ 'active': fetching }"></div>

      <table class="ui table">
        <thead>
        <tr>
          <th>
            Title
          </th>
          <th>
            Price
          </th>
          <th>
            Description
          </th>
          <th>
            Letter
          </th>
          <th class="collapsing">
            Actions
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="service in services">
          <td>{{ service.title }}</td>
          <td>€ {{ numeral(service.price).format('0,0.00') }}</td>
          <td>{{ service.description }}</td>
          <td class="collapsing"><strong>{{ service.letter }}</strong></td>
          <td class="collapsing">
            <div class="ui tiny buttons">
              <div class="ui button" @click="editService(service)"><i class="edit icon"></i> Edit Service</div>
              <div class="ui floating dropdown blue icon button" @click.stop="">
                <i class="dropdown icon"></i>
                <div class="menu">
                  <div class="item" @click="editService(service)"><i class="edit icon"></i> Edit Service</div>
                  <div class="item" @click="triggerDeleteService(service)"><i class="trash icon"></i> Delete Service</div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="ui small basic delete modal">
      <div class="header" style="text-align: center">
        Are you sure?
      </div>
      <div class="content" style="text-align: center">
        Delete service <strong v-if="serviceForDelete">{{ serviceForDelete.title }}</strong>
      </div>
      <div class="actions" style="text-align: center">
        <div class="ui red basic cancel inverted button">
          <i class="remove icon"></i>
          No
        </div>
        <div class="ui green ok inverted button" @click="deleteService(serviceForDelete)">
          <i class="checkmark icon"></i>
          Yes
        </div>
      </div>
    </div>

    <div class="ui small modal" id="serviceModal">
      <i class="close icon"></i>
      <div class="header">
        <span v-if="service._id">Edit Service</span>
        <span v-else>Add Service</span>
      </div>
      <div class="content">
        <form class="ui form" @submit.prevent>
          <div class="ui field">
            <label>Title</label>
            <input class="ui input" v-model="service.title">
          </div>
          <div class="fields">
            <div class="twelve wide field">
              <label>Price</label>
              <div class="ui right icon input">
                <input class="ui input" type="number" step="any" v-model="service.price">
                <i class="euro icon"></i>
              </div>
            </div>
            <div class="four wide field">
              <label>&nbsp;</label>
              <div class="ui right icon input">
                <select class="ui selection" v-model="service.priceType">
                  <option value="fixed">Fixed</option>
                  <option value="perPerson">Per Person</option>
                </select>
              </div>
            </div>
          </div>
          <div class="ui field">
            <label>Description</label>
            <textarea class="ui input" v-model="service.description" rows="3"></textarea>
          </div>
          <div class="ui field">
            <label>Letter in admin booking panel</label>
            <input class="ui input" v-model="service.letter" maxlength="1">
          </div>
        </form>
      </div>
      <div class="actions">
        <div class="ui icon cancel button">
          <i class="delete icon"></i> Close
        </div>
        <div class="ui icon positive button" @click="saveService">
          <i class="checkmark icon"></i> Save Service
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'

  export default {
    data() {
      return {
        'services': [],
        'settings': {},
        'service': {
          title: null,
          price: null,
          priceType: "fixed",
          description: null,
          happens: null,
          letter: null
        },
        'serviceForDelete': null,
        'fetching': false,
        'moment': moment,
        'numeral': numeral
      }
    },
    mounted() {
      this.fetchServices()

      services.additonalServiceService.on('created', () => {
        this.fetchServices()
      })
      services.additonalServiceService.on('patched', () => {
        this.fetchServices()
      })
      services.additonalServiceService.on('removed', () => {
        this.fetchServices()
      })

      $('.huge.menu').visibility({
        type: 'fixed',
        offset: 0
      });
    },
    beforeDestroy() {
      $('.ui.modals').remove()
    },
    methods: {
      fetchServices() {
        this.fetching = true

        services.additonalServiceService.find().then(services => {
          this.services = services.data
          this.fetching = false
          this.initDropdown()
        })
      },
      initDropdown() {
        setTimeout(() => {
          $('.ui.dropdown').dropdown()
        }, 50)
      },
      triggerMenu() {
        $('.ui.sidebar').sidebar('toggle')
      },
      openReservationDetails(reservation) {
        this.editReservation = reservation
        $('#reservationModal').modal({}).modal('show')
      },
      showServiceModal() {
        $('#serviceModal').modal('show')
      },
      editService(service) {
        this.service = service
        this.showServiceModal()
      },
      addService() {
        this.service = {
          title: null,
          price: null,
          description: null,
          happens: null,
          letter: null
        }
        this.showServiceModal()
      },
      saveService() {


        if (this.service._id) {
          services.additonalServiceService.patch(this.service._id, this.service).then(service => {
            toastr.success('Service saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        } else {
          services.additonalServiceService.create(this.service).then(service => {
            toastr.success('Service saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        }
      },
      triggerDeleteService(service) {
        this.serviceForDelete = service

        $('.ui.delete.modal').modal('show')
      },
      deleteService(service) {
        services.additonalServiceService.remove(service._id).then(service => {
          toastr.info(`Removed service <strong>${service.title}</strong>`, 'Service removed!')
        })
      }
    },
    components: {}
  }
</script>

<style scoped>
  .ui.calendar input {
    border: none;
    font-size: 1.3rem;
  }

  .red.item {
    color: #771d14;
  }

  .calendar.item {
    padding: 4px 1px 0;
  }

  .text.input input {
    border: none;
  }

  .text.input.item {
    padding: 10px;
  }

  .huge.menu.placeholder {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// Services.vue?0ca401a4